module.exports = __webpack_public_path__ + "static/media/is_management_company.3e6da1f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_management_company.svg
// module id = 1527
// module chunks = 0